import { render, staticRenderFns } from "./DunningMailLawyer.vue?vue&type=template&id=7d2db7cb"
import script from "./DunningMailLawyer.vue?vue&type=script&lang=js"
export * from "./DunningMailLawyer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports